module.exports = __webpack_public_path__ + "img/banner-3-mobile.bfaf63ff.png";